// // export const CustYellow = "#eae972";
// // export const CustBlue = "#32d9b0";
// // export const CustRed = "#e25ad0";
// // export const CustGrey = "#d4d2d2";
// // export const CustOrange = "#ffa5006b";

// export const CustYellow = "#6a3db7";
// export const CustBlue = "#042150";
// export const CustRed = "#e25ad0";
// export const CustGrey = "#042150";
// export const CustOrange = "#042150";





export const CustYellow = "#774797";
// export const CustBlue = "#32d9b0";
// export const CustRed = "#e25ad0";

export const CustOrange = "#eecd65";

// export const CustYellow = "#6a3db7";
export const CustBlue = "#784697";
export const CustRed = "#e25ad0";
// export const CustGrey = "#042150";
export const CustGrey = "#eecd65";
// export const CustOrange = "#042150";

export const DarkBackgroundColor = "rgba(96, 81, 181, 0.47)";

export const NavBarColor = "#0b5bdb94";
export const ButtonColor = "#0688e4";
export const LightTextColor = "#ffffff";
export const DarkTextColor = "#000000";

// export const ButtonColor = "#0688e4";

// Purple: 6a3db7
// 12:56
// Dk blue: 042150
// 12:56
// Yellow: ffc100